<div class="form-container" *ngIf="helperService.fromPage != 'goldfinch'">
  <span mat-dialog-title class="popup-header">Enter New Integration Bridge Name</span>
  <div mat-dialog-content class="dilog-popup">
    <form [formGroup]="form">
      <mat-form-field class="popup-label" appearance="outline">
        <mat-label>Integration Bridge Name</mat-label>
        <input matInput placeholder="Enter integration bridge name" formControlName="name"
          (keydown)="bridgenameCheck($event)" required />
      </mat-form-field>
    </form>
  </div>
  <div class="btn-grid">
    <button mat-raised-button class="btn" (click)="dialogRef.close(false)">
      Cancel
    </button>
    <button mat-raised-button class="btn btn-submit" (click)="submit(form.value)">
      Submit
    </button>
  </div>
</div>

<div class="form-container" *ngIf="helperService.fromPage == 'goldfinch'">
  <span mat-dialog-title class="popup-header">Enter New Neocortex Conversation Name</span>
  <div mat-dialog-content class="dilog-popup">
    <form [formGroup]="form">
      <mat-form-field class="popup-label" appearance="outline">
        <mat-label>Neocortex Conversation Name</mat-label>
        <input matInput placeholder="Your Neocortex Conversation Name" formControlName="name" required/>
      </mat-form-field>
    </form>
  </div>
  <div class="btn-grid">
    <button mat-raised-button class="btn" (click)="dialogRef.close(false)">
      Cancel
    </button>
    <button mat-raised-button class="btn btn-submit" (click)="submit(form.value)">
      Submit
    </button>
  </div>
</div>